import React, { useCallback, useEffect } from 'react';
import { useHistory, useLocation, useParams, useRouteMatch } from 'react-router-dom';
import { useApi, useWorkspace } from '~/contexts';
import { PageLoader } from '~/routes/public/pages';

function ClientRedirect() {
  const api = useApi();
  const { workspace } = useWorkspace();
  const { clientId } = useParams();
  const { url } = useRouteMatch();
  const history = useHistory();
  const location = useLocation();

  const fetchData = useCallback(async () => {
    try {
      const { data } = await api.www.workspaces(workspace.id).clients(clientId).key();
      const suffix = location.pathname.slice(url.length);
      history.replace({
        pathname: `/app/${workspace.key}/portfolio/clients/${data.key}${suffix}`,
        search: location.search,
        hash: location.hash,
      });
    } catch {
      history.replace(`/app/${workspace.key}/portfolio/clients`);
    }
  }, [api, workspace, clientId, url, location, history]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return <PageLoader />;
}

export default ClientRedirect;
